<template>
    <div>
        <div class="search-form" v-if="search || expand">
            <input class="form-control" v-model="query">
            <div class="page-post-title-search" @click="handleSearch">
                <i class="icon icon-search"></i>
            </div>
        </div>
        <div class="page-post-title-search" @click="search = !search" v-else>
            <i class="icon icon-search"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchArticle",
    props: ['expand', 'query'],
    data() {
        return {
            search: false,
        }
    },
    methods: {
        handleSearch() {
            this.$emit('search', this.query)
        }
    }
}
</script>

<style scoped>
.search-form {
    display: flex;
    align-items: center;
}
.search-form .page-post-title-search {
    margin-left: 5px;
}
.page-post-title-search {
    background-color: #C4C4C4;
    border-radius: 50%;
    padding: 6px;
}
.page-post-title-search .icon {
    background: #fff;
    width: 20px;
    height: 20px;
}
</style>
